import * as React from 'react';

import {
  basePickerConfig,
  mergeConfig,
  PickerConfig,
  PickerConfigInternal
} from '../../config/config';

type Props = PickerConfig &
  Readonly<{
    children: React.ReactNode;
  }>;

const ConfigContext = React.createContext<PickerConfigInternal>(
  basePickerConfig()
);

export function PickerConfigProvider({ children, ...config }: Props) {
  const mergedConfig = useSetConfig(config);

  return (
    <ConfigContext.Provider value={mergedConfig}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useSetConfig(config: PickerConfig) {
  const [mergedConfig, setMergedConfig] = React.useState(() =>
    mergeConfig(config)
  );

  React.useEffect(() => {
    if (avoidRefresh(config as Props, (mergedConfig as unknown) as Props)) {
      return;
    }
    setMergedConfig(mergeConfig(config));
    // not gonna...
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config.customEmojis?.length, config.open]);

  return mergedConfig;
}

export function usePickerConfig() {
  return React.useContext(ConfigContext);
}

function avoidRefresh(prev: Props, next: Props) {
  return (
    prev.customEmojis?.length === next.customEmojis?.length &&
    prev.open === next.open
  );
}
